import { render, staticRenderFns } from "./formerUniverse.vue?vue&type=template&id=6fdbb4db&"
import script from "./formerUniverse.vue?vue&type=script&lang=js&"
export * from "./formerUniverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports